import { gql } from '@edreamsodigeo/frontend-api-client';
import { api as sectionLocationFragment } from './sectionLocation';
import { api as carrierFragment } from './carrier';
import { api as technicalStopoverFragment } from './technicalStopover';

export const api = gql`
  fragment Section on Section {
    id
    departureDate
    arrivalDate
    duration
    departure {
      ...SectionLocation
    }
    destination {
      ...SectionLocation
    }
    carrier {
      ...CarrierInfo
    }
    operatingCarrier {
      ...CarrierInfo
    }
    technicalStops {
      ...TechnicalStop
    }
    cabinClass
    flightCode
    departureTerminal
    arrivalTerminal
    vehicleModel
    transportType
    insuranceOffer {
      url
      id
      policy
    }
  }

  ${sectionLocationFragment}
  ${carrierFragment}
  ${technicalStopoverFragment}
`;
